import axios from 'axios';
import * as E from '../entities';
import { WebEntity, WebEntityName } from '../entities/types';
import { AppDispatch, AppGetState } from '../store';
import { tokenConfig } from '../utils/header';
import { getEntitiesAction } from './entitiesActions';
import { handleError } from '../components/PopAlert';
import { SimpleObject, StudyConfigType, StudyType } from '../types';

const refreshEntity =
  (entity: WebEntity<any>, query?: SimpleObject) =>
  async (dispatch: AppDispatch, getState: AppGetState) =>
    await getEntitiesAction(
      entity.name as WebEntityName,
      entity.endpoint,
      query ? { query } : {}
    )()(dispatch, getState);

export const refreshMapElements = () => async (dispatch: AppDispatch, getState: AppGetState) => {
  try {
    const res = await axios.patch(
      `/api/mapElements/regenerateMapElements`,
      {},
      tokenConfig(getState)
    );
    return res;
  } catch (error) {
    console.error(error);
  }
};

export const addStudy =
  ({
    nombreSimulacion,
    descripcionSimulacion,
    typeStudy,
    alimentadorId,
    config
  }: {
    nombreSimulacion: string;
    descripcionSimulacion: string;
    typeStudy: StudyType;
    alimentadorId: string;
    config: StudyConfigType;
  }) =>
  async (dispatch: AppDispatch, getState: AppGetState) => {
    try {
      const res = await axios.post(
        `/api/estudios/add`,
        {
          nombreSimulacion,
          descripcionSimulacion,
          typeStudy,
          alimentadorId,
          config
        },
        tokenConfig(getState)
      );

      const simulacionId = res && res?.data.length > 0 ? res.data[0]?.simulacionId : undefined;

      if (simulacionId) {
        await axios.post(`/api/estudios/refresh`, { simulacionId }, tokenConfig(getState));
      }

      await refreshEntity(E.MyStudiesEntity)(dispatch, getState);
      return res;
    } catch (error) {
      handleError({ error, entityName: E.MyStudiesEntity.name, dispatch });
    }
  };
